export const NEWSLETTER_COUNT = "200k";
